import Vue from 'vue'
import { $themeConfig } from '@themeConfig'

export function fetchContractors(limit, offset, query) {
    return Vue.axios.get(
        `${$themeConfig.app.backUrl}/contractors?limit=${limit}&offset=${offset}&search=${query}`
    )
}
